var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42 0C18.8413 0 0 18.8408 0 41.9998C0 65.1588 18.8413 84 42 84C65.1587 84 84 65.1588 84 41.9998C84 18.8408 65.1591 0 42 0ZM66.1171 34.9057L39.7307 61.292C38.6087 62.4139 37.1173 63.0314 35.5308 63.0314C33.9443 63.0314 32.4529 62.4139 31.3309 61.292L17.8829 47.844C16.7609 46.722 16.143 45.2306 16.143 43.6441C16.143 42.0572 16.7609 40.5658 17.8829 39.4438C19.0044 38.3219 20.4958 37.704 22.0827 37.704C23.6692 37.704 25.1611 38.3219 26.2826 39.4443L35.5304 48.6916L57.7165 26.5055C58.8385 25.3836 60.3299 24.7661 61.9164 24.7661C63.5029 24.7661 64.9943 25.3836 66.1163 26.5055C68.4329 28.8222 68.4329 32.5899 66.1171 34.9057Z",
    fill: "#01D894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImage);
export default __webpack_public_path__ + "static/media/successImage.81cebfef64145c7dceb870bf4d7d371c.svg";
export { ForwardRef as ReactComponent };